import { belongsTo } from '@ember-data/model';
import Super from './clinician-document-review';

export default class ClinicianInsuranceInfoReview extends Super {
  @belongsTo('insurance-info-request-connection', {
    async: false,
    inverse: 'clinicianInsuranceInfoReview',
  })
  insuranceInfoRequestConnection;
}
